<template>
	<Radar :data="data" :options="options" />
</template>

<script>
import { Radar } from 'vue-chartjs'
import { useChart } from '@/composables/useChart'

const RadarChart = {
	props: ['data', 'options'],
	components: { Radar },
	setup () {
		useChart()
	}
}

export default RadarChart
export { RadarChart as mdbRadarChart }
</script>
